<!-- <app-loader
  [apiCall]="this.apiCall"
  [loader]="true"
  [loaderId]="'accountMoveBindings'"
  style="min-height: 200px"
>
</app-loader> -->
@let accountMove = this.accountMove$ | async;
@if (accountMove) {
  @if (this.bindType() === 'Repayment') {

    <div class="row mb-2">
      <div class="col-6 col-md">
        <label class="form-title-label" translate>{{ labelInvoices() }}</label>
        <table class="table table-striped table-hover">
          <tbody>
            @for (accountMove of accountMove.issuingAccountMoves; track accountMove.id) {
              @for (accountMoveLine of accountMove.accountMoveLines; track accountMoveLine.id) {
                <tr>
                  <td>
                    {{ accountMove.name }}
                  </td>
                  <td>
                    {{ accountMoveLine.unitPriceClientView | currency : "EUR" }}
                  </td>
                  <td>
                    {{
                      accountMove.periodStartDate | period : accountMove.periodEndDate
                    }}
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

      <div class="col">
        <label class="form-title-label" translate>{{ labelPayments() }}</label>
        <table class="table table-striped table-hover">
          <tbody>
            @for (payment of accountMove.payingAccountMoves; track payment.id) {
              @for (accountMoveLine of payment.accountMoveLines; track accountMoveLine.id) {
                <tr>
                  <td>
                    @if (this.isVendorInvoice()) {
                      {{ payment.name }}
                    } @else {
                      {{ accountMoveLine.paymentModeLoc }}
                    }
                  </td>
                  <td>
                    {{ accountMoveLine.unitPriceClientView | currency : "EUR" }}
                  </td>
                  <td>
                    @if (this.isVendorInvoice()) {
                      {{ payment.periodStartDate | period : payment.periodEndDate }}
                    } @else {
                      {{ accountMoveLine.creationDate | toLocalTime : "dd/MM/yyyy" }}
                    }
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >ACCOUNTMOVE_LBL_TOTAL_INVOICE</label
          >
          <div class="col-auto">
          <span class="form-control-plaintext form-control-sm">
            {{
              accountMove.issuingAccountMoves
                | accountmovesamount
                | currency : "EUR"
            }}
          </span>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >ACCOUNTMOVE_LBL_TOTAL_PAYMENT</label
          >
          <div class="col-auto">
          <span class="form-control-plaintext form-control-sm">
            {{
              accountMove.payingAccountMoves
                | accountmovesamount
                | currency : "EUR"
            }}
          </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >ACCOUNTMOVE_LBL_BALANCE</label
          >
          <div class="col">
          <span class="form-control-plaintext form-control-sm">
            {{
              (accountMove.issuingAccountMoves | accountmovesamount) +
              (accountMove.payingAccountMoves | accountmovesamount)
                | currency : "EUR"
            }}
          </span>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

  } @else {
    <div class="row mb-2">
      <div class="col-6 col-md">
        <label class="form-title-label" translate>{{ labelPayments() }}</label>
        <table class="table table-striped table-hover">
          <tbody>
            @for (payment of accountMove.payingAccountMoves; track payment.id) {
              @for (accountMoveLine of payment.accountMoveLines; track accountMoveLine.id) {
                <tr>
                  <td>
                    @if (this.isVendorInvoice()) {
                      {{ payment.name }}
                    } @else {
                      {{ accountMoveLine.paymentModeLoc }}
                    }
                  </td>
                  <td>
                    {{ accountMoveLine.unitPriceClientView | currency : "EUR" }}
                  </td>
                  <td>
                    @if (this.isVendorInvoice()) {
                      {{ payment.periodStartDate | period : payment.periodEndDate }}
                    } @else {
                      {{ accountMoveLine.creationDate | toLocalTime : "dd/MM/yyyy" }}
                    }
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

      <div class="col">
        <label class="form-title-label" translate>{{ labelInvoices() }}</label>
        <table class="table table-striped table-hover">
          <tbody>
            @for (accountMove of accountMove.issuingAccountMoves; track accountMove.id) {
              @for (accountMoveLine of accountMove.accountMoveLines; track accountMoveLine.id) {
                <tr>
                  <td>
                    @if (this.linkTo()) {
                      <app-link-to [url]="'/Insurance/Contracts/Details/'"
                                   [label]="accountMove.name"
                                   [id]="accountMove.contractUniqueId" />
                    } @else {
                      {{ accountMove.name }}
                    }
                  </td>
                  <td>
                    {{ accountMoveLine.unitPriceClientView | currency : "EUR" }}
                  </td>
                  <td>
                    {{
                      accountMove.periodStartDate | period : accountMove.periodEndDate
                    }}
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >ACCOUNTMOVE_LBL_TOTAL_PAYMENT</label
          >
          <div class="col-auto">
          <span class="form-control-plaintext form-control-sm">
            {{
              accountMove.payingAccountMoves
                | accountmovesamount
                | currency : "EUR"
            }}
          </span>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >ACCOUNTMOVE_LBL_TOTAL_INVOICE</label
          >
          <div class="col-auto">
          <span class="form-control-plaintext form-control-sm">
            {{
              accountMove.issuingAccountMoves
                | accountmovesamount
                | currency : "EUR"
            }}
          </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >ACCOUNTMOVE_LBL_BALANCE</label
          >
          <div class="col">
          <span class="form-control-plaintext form-control-sm">
            {{
              (accountMove.payingAccountMoves | accountmovesamount) -
              (accountMove.issuingAccountMoves | accountmovesamount)
                | currency : "EUR"
            }}
          </span>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
  }
}
